// @flow

import React from 'react';

import {
  getRetailTableCellObject,
  getFormattedDate,
  getFormattedTime,
  roundOff
} from '../../../../services/helpers';

const creditKey = 'credit';
const debitKey = 'debit';
export const downloadFileName = 'Wallet_Report.xlsx';

const bpPassbookDashboardConfig = {
  columns: [
    {
      headerClassName: 'zt-custom-th',
      Header: 'Date-Time',
      sortable: false,
      className: 'zt-custom-td',
      Cell: (row: Object) =>
        getRetailTableCellObject(
          getFormattedDate(row.original.createdAt),
          getFormattedTime(row.original.createdAt)
        )
    },
    {
      headerClassName: 'zt-custom-th',
      Header: 'Remarks',
      className: 'zt-custom-td',
      sortable: false,
      Cell: (row: Object) => (
        <div className="l-col a-center">
          <span>
            {row.original.transactionHeader || ''}{' '}
            {row.original.transactionSubHeader || ''}
          </span>
          <span>{row.original.reference}</span>
        </div>
      )
    },
    {
      headerClassName: 'zt-custom-th',
      Header: 'Transaction No.',
      className: 'zt-custom-td',
      sortable: false,
      accessor: 'txnNo'
    },
    {
      Header: 'Credit',
      headerClassName: 'zt-custom-th',
      sortable: false,
      className: 'no-opac zt-custom-td',
      Cell: (row: Object) => (
        <div className="a-center">
          {row.original.transactionType &&
          row.original.transactionType.toLowerCase() === creditKey
            ? roundOff(row.original.amount)
            : '--'}
        </div>
      )
    },
    {
      Header: 'Debit',
      headerClassName: 'zt-custom-th',
      sortable: false,
      className: 'zt-custom-td',
      Cell: (row: Object) => (
        <div className="a-center">
          {row.original.transactionType &&
          row.original.transactionType.toLowerCase() === debitKey
            ? roundOff(row.original.amount)
            : '--'}
        </div>
      )
    },
    {
      Header: 'Closing Balance',
      headerClassName: 'zt-custom-th',
      sortable: false,
      className: 'zt-custom-td',
      Cell: (row: Object) => (
        <div>
          {row.original.closingBalance
            ? roundOff(row.original.closingBalance)
            : '--'}
        </div>
      )
    }
  ],
  className: 'zoomTableLegacyWrapper',
  noDataText: 'No transactions found',
  minRows: 0,
  pageSizeOptions: [7, 10, 15, 25, 50, 100],
  style: { maxHeight: 'calc(100vh - 18rem)' }
};

export default bpPassbookDashboardConfig;
